export default {
    cart: [],
    total_price: 0
};